import {  AfterViewChecked, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonComponent, LinkCellComponent, TableColumn, TableComponent } from 'ddmo-storybook-lib';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '../../../../shared/services/shared.service';
import { catchError, forkJoin, of, throwError } from 'rxjs';
import { LoaderService } from '../../../../shared/services/loader.service';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';
import { DeletePopupComponent, UserTermedComponent} from '../../../popups/processing/processing.component';
import { MatDialog } from '@angular/material/dialog';
import { DemographicService } from '../../../wizard/services/demographics.service';
import { environment } from '../../../../../environments/environment';
import { WorkHistoryService } from '../../../wizard/services/work-history.service';
import {v4 as uuid4} from 'uuid';
import { AuthTokenService } from '../../../../shared/services/auth0-token.service';
import { PreviewModalComponent } from '../../pages/preview/preview-model.component';
import { DocumentPreviewComponent } from '../../pages/document/document-modal.compoment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DentalCredentialsService } from '../../../wizard/services/dental-credentials.service';
interface CredentialStatusResult  {
  finalStatus: string ;
  action: string;
}
@Component({
    selector: 'app-main',
    imports: [CommonModule, ButtonComponent, TableComponent, LoaderComponent],
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss'
})
export class MainComponent implements OnInit,AfterViewChecked {
  public tableData:any = []  
  public dataSource = new MatTableDataSource<any>([]);
  public tableColumns: TableColumn[] = [
    {
      columnId: 'delete',
      columnLabel: '',
      sort: false,
      headerData: null,
      columnData: {
        cellType: LinkCellComponent ,
        data: {
          label: 'delete',
          actionData: "status",
        }
      },
      caseInsensitive: false,
    },   
    {
      columnId: 'name',
      columnLabel: 'Name',
      sort: false,
      headerData: null,
      columnData: null,
      caseInsensitive: false,
    },
    {
      columnId: 'credentialingDates',
      columnLabel: 'Credentialing dates',
      sort: false,
      headerData: null,
      columnData: null,
      caseInsensitive: false,
    },
    {
      columnId: 'recred',
      columnLabel: 'Recred',
      sort: false,
      headerData: null,
      columnData: null,
      caseInsensitive: false,
    },
    {
      columnId: 'status',
      columnLabel: 'Status',
      sort: false,
      headerData: null,
      columnData: null,
      caseInsensitive: false,
    },
    {
      columnId: 'description',
      columnLabel: '',
      sort: false,
      headerData: null,
      columnData: {
        cellType: LinkCellComponent ,
        data: {
          label: 'description',
          actionData: "'description'",
        },
        otherParams : {
          'actionKey' : 'description'
        }
      },
      caseInsensitive: false,
    }
  ];
  action = ""
  SearchCredentialPayload:any = {}
  getCredentialpayload:any = {}
  showActionRequired = false
  impersonatedUser:any = localStorage.getItem("impersonatedUser") ?? ""
  hasDelete:boolean = false;
  prEmail = "credentialing@deltadentalmo.com"
  isLoading = false
  @ViewChild('tableWrapper', { static: false }) tableWrapper!: ElementRef<HTMLElement>;
  userDetails: any = JSON.parse(localStorage.getItem('loggedUserDetails')!) || [];

  constructor(private router: Router,private sharedService: SharedService,private loader:LoaderService,
    private el: ElementRef,
    private renderer: Renderer2,public dialog: MatDialog,private demographicService : DemographicService,
    private urlRoute: ActivatedRoute, private workHistoryService:WorkHistoryService, private authService: AuthTokenService,
    private dentalCredentialsService: DentalCredentialsService
  ) { 
    this.sharedService.username$.pipe(takeUntilDestroyed()).subscribe(name => {
      const demographics = JSON.parse(localStorage.getItem("demographics") || '{}')
      if (!demographics?.firstName && !demographics?.lastName) {
        if(this.dataSource.data?.length>0){
          const fullName = name
          ? name.charAt(0).toUpperCase() + name.slice(1)
          : '';
          this.tableData = this.tableData.map((row:any, i:any) =>
            i === 0 ? { ...row, name: fullName } : row
          );
        this.dataSource.data = this.tableData;
        }
      }
    });
  }

  ngOnInit(): void {
    window.scrollTo({top: 0, behavior: 'smooth' });
    this.loader.show()
    this.isLoading = true
    this.urlRoute.queryParams.subscribe(params => {
      if (params['code'] && !localStorage.getItem('auth0_id_token')) {
        this.callToken(params);
      }else{
        if(this.impersonatedUser){
          this.setImpersonatedPayload();
        }else if(localStorage.getItem("loggedUserDetails")){
          this.loader.show()
          this.isLoading = true
          this.getCredentialingResources()
          this.SearchCredentialPayload = JSON.parse(localStorage.getItem('SearchCredentialPayload') || this.SearchCredentialPayload) 
          this.getCredentialpayload = JSON.parse(localStorage.getItem('getCredentialpayload') || this.getCredentialpayload)
          this.callSearchAndGetCredentaildataApis()
        }else if(localStorage.getItem("user_email")&&!this.impersonatedUser){
          this.getLoggedUserDetails()
        }else{
        this.loader.hide()
        this.isLoading = false
        this.router.navigate(['/login'])
          
        }
      }
    });
  }

  openPreview() {
    this.dialog.open(PreviewModalComponent, {
      width: '90%',
      maxHeight: '90vh',
      panelClass: 'preview-dialog'
    });
  }

  openDocument() {
    this.dialog.open(DocumentPreviewComponent, {
      width: '90%',
      maxHeight: '90vh',
      panelClass: 'document-dialog',
      data: {}
    });
  } 
  ngAfterViewChecked(): void {
   this.addDeleteIconClass()
   this.addPreviewIconClass()
   this.addDocumentIconClass()
   this.addOjStatusClasses()
  }
// Map status text to a landing-specific CSS class for color coding.
  getOjStatusClass(status: string): string {
    const value = (status || '').trim().toLowerCase();

    if (value.startsWith('draft')) {
      return 'oj-status-draft';
    }
    
    if (value.startsWith('recredential due')) {
      return 'oj-status-recred';
    }
    
    if (value.startsWith('pending')) {
      return 'oj-status-pending';
    }

    if (value.startsWith('in progress')) {
      return 'oj-status-in-progress';
    }

    if (value.startsWith('approved')) {
      return 'oj-status-approved';
    }

    if (value.startsWith('rejected')) {
      return 'oj-status-rejected';
    }

    if (value.startsWith('submitted')) {
      return 'oj-status-submitted';
    }

    if (value.startsWith('ended')) {
      return 'oj-status-ended';
    }

    return '';
  }

  private addDeleteIconClass(): void {
    if(this.tableWrapper){
    const deleteLink = this.tableWrapper.nativeElement.querySelector(
      'a[aria-label="delete"]'
    );
 
    if (deleteLink && !deleteLink.classList.contains('material-icons')) {
      this.renderer.addClass(deleteLink, 'material-icons');
      this.renderer.addClass(deleteLink, 'docanchor');
      deleteLink.innerHTML = `<mat-icon class="landingIcons" title="Delete application">delete</mat-icon>`
    }
  }
  }
  private addPreviewIconClass(): void {
    if(this.tableWrapper){
    const previewLink = this.tableWrapper.nativeElement.querySelector(
      'a[aria-label="preview"]'
    );
 
    if (previewLink && !previewLink.classList.contains('material-icons')) {
      this.renderer.addClass(previewLink, 'material-icons');
      this.renderer.addClass(previewLink, 'docanchor');
      previewLink.innerHTML = `<mat-icon class="landingIcons" title="Application preview">preview</mat-icon>`
    }
  }
  }
  private addDocumentIconClass(): void {
    if (this.tableWrapper) {
      const documentLink = this.tableWrapper.nativeElement.querySelector(
        'a[aria-label="description"]'
      );

      if (documentLink && !documentLink.classList.contains('material-icons')) {
        this.renderer.addClass(documentLink, 'material-icons');
        this.renderer.addClass(documentLink, 'docanchor');
        documentLink.innerHTML = `<mat-icon class="landingIcons" title="View documents">description</mat-icon>`
      }
    }
  }

  // Apply mapped status classes to rendered desktop table status cells.
  private addOjStatusClasses(): void {
    if (!this.tableWrapper) {
      return;
    }

    const statusCells = this.tableWrapper.nativeElement.querySelectorAll('.cdk-column-status');

    statusCells.forEach((cell: Element) => {
      const statusCell = cell as HTMLElement;
      const statusClass = this.getOjStatusClass(statusCell.textContent || '');
      
      this.renderer.removeClass(statusCell, 'oj-status-draft');
      this.renderer.removeClass(statusCell, 'oj-status-pending');
      this.renderer.removeClass(statusCell, 'oj-status-in-progress');
      this.renderer.removeClass(statusCell, 'oj-status-approved');
      this.renderer.removeClass(statusCell, 'oj-status-rejected');
      this.renderer.removeClass(statusCell, 'oj-status-submitted');
      this.renderer.removeClass(statusCell, 'oj-status-ended');
      this.renderer.removeClass(statusCell, 'oj-status-recred');

      if (statusClass) {
        this.renderer.addClass(statusCell, statusClass);
      }
    });
  }

  onStart() {
    this.loader.show()
    this.action = "start"
    localStorage.setItem('Action',this.action)
    this.startCredentialing()
  }
  downloadPdf() {
    const link = document.createElement('a');
    link.href = 'assets/pdf/Initial cred application.pdf';
    link.download = 'InitialCredApplication.pdf';
    link.click();
  }
  onRecred(item: any) {
    localStorage.setItem('Action',this.action)
    if(item && item.action == 'Recred'){
      this.startCredentialing()
    }else{
      this.router.navigate(['/credentialing/information']);
    }
  }
  onTableClick(event:any){
    if(event){
      if(event == 'Draft' || event == 'Submitted'){
        this.deletePopupCall()
      }
      if(event?.otherParams && event?.otherParams?.actionKey == "preview") {
        this.openPreview();
      }
      if(event?.otherParams && event?.otherParams?.actionKey == "description") {
        this.openDocument();
      }
    }else{
      localStorage.setItem('Action',this.action)
      this.loader.show()
      if(this.action == 'Recred'){
      this.startCredentialing()
      }else{
        this.loader.show()
        setTimeout(() => {
          this.router.navigate(['/credentialing/information']);
        });
      }
    }
  }
   callSearchAndGetCredentaildataApis(){
    this.loader.show()
    this.isLoading = true
    this.tableColumns = [
      {
          columnId: 'delete',
          columnLabel: '',
          sort: false,
          headerData: null,
          columnData: {
              cellType: LinkCellComponent,
              data: { label: 'delete', actionData: "status" }
          },
          caseInsensitive: false,
      },
      {
          columnId: 'name',
          columnLabel: 'Name',
          sort: false,
          headerData: null,
          columnData: null,
          caseInsensitive: false,
      },
      {
          columnId: 'credentialingDates',
          columnLabel: 'Credentialing dates',
          sort: false,
          headerData: null,
          columnData: null,
          caseInsensitive: false,
      },
      {
          columnId: 'recred',
          columnLabel: 'Recred',
          sort: false,
          headerData: null,
          columnData: null,
          caseInsensitive: false,
      },
      {
          columnId: 'status',
          columnLabel: 'Status',
          sort: false,
          headerData: null,
          columnData: null,
          caseInsensitive: false,
      },
      {
          columnId: 'description',
          columnLabel: '',
          sort: false,
          headerData: null,
          columnData: {
              cellType: LinkCellComponent,
              data: { label: 'description', actionData: "'description'" },
              otherParams: { 'actionKey': 'description' }
          },
          caseInsensitive: false,
      }
  ];
  this.hasDelete = false; 
    if(environment.TRIGGER_CREDENTIALING_REQUEST == "true") {
      this.sharedService.getCredentialingRequestStatus(this.getCredentialpayload).subscribe( respnse => {
      });
    }
      this.clearLocalStorageData()
       forkJoin({
      existing: this.sharedService.searchCredentiallingData(this.SearchCredentialPayload).pipe(
        catchError(err => of({ error: true, message: err }))
      ),
      credential: this.sharedService.getCredentiallingData(this.getCredentialpayload).pipe(
        catchError(err => of({ error: true, message: err }))
      )
    }).subscribe(results => {
      if (results.existing.error) {
        this.sharedService.logError("APIFailed","FileMainComponent - searchCredentiallingData, Method:callSearchAndGetCredentaildataApis", this.router.url.split('?')[0], results.existing.message).subscribe();
        if(results.existing.message.status == 401){
          this.loader.hide()
          this.isLoading = false
          this.router.navigate(['/login'])
          return
        }
      }
      if (results.credential.error) {
        this.sharedService.logError("APIFailed","FileMainComponent - getCredentiallingData, Method:callSearchAndGetCredentaildataApis", this.router.url.split('?')[0], results.credential.message).subscribe();
        if(results.credential.message.status == 401){
          this.loader.hide()
          this.isLoading = false
          this.router.navigate(['/login'])
          return
        }
      }
      this.formatTableData(results.existing,results.credential)
      this.setLocalstorageDetails(results.existing,results.credential)
    });
   }

  formatTableData(Existing: any, credential: any) {
    let deleteicon = ''
    let previewicon = ''
    let documenticon = ''
    let status = ""
    if (Existing) {
      if((Existing && Existing.error) && (credential && credential.error)){
        if(Existing.message.status == 404 && credential.message.status == 404){
        this.dataSource.data = []
        this.loader.hide()
        this.isLoading = false
        }
      }else if ((credential && credential.error && credential.message.status == 404) &&( Existing['dentistInfo'] && Existing['dentistInfo']['credentialingPeriod'] == null )) {
        this.dataSource.data = []
        this.loader.hide()
        this.isLoading = false
      }else {
        const credentialEventStatusRaw = credential.credentialingEvent?.eventStatus || ''
        const overjetStatusRaw = credential.credentialingEvent?.overJetStatus || ''
        const normalizedEventStatus = `${credentialEventStatusRaw}`.trim().toLowerCase()
        const normalizedOverjetStatus = `${overjetStatusRaw}`.trim().toUpperCase().replace(/\s+/g, '_')
        const isInProgressApproved = normalizedEventStatus == 'in progress' && normalizedOverjetStatus == 'APPROVED'
        if(normalizedEventStatus == 'draft' || normalizedEventStatus == 'submitted'){
          if(normalizedEventStatus == 'draft')
          {
            deleteicon = 'delete'
            this.hasDelete = true;
            status = 'Draft'
            localStorage.setItem('credentialingEventId', credential['credentialingEvent']['credentialingEventId'])
          }
          if(normalizedEventStatus == 'submitted'){
            previewicon = 'preview'
            documenticon = 'description'
            this.tableColumns = this.tableColumns.filter(column => column.columnId !== 'delete')
          }else{
            this.tableColumns = this.tableColumns.filter(column => column.columnId !== 'preview')
            this.tableColumns = this.tableColumns.filter(column => column.columnId !== 'description')
          }
        }else{
          if(Existing['dentistInfo']?.credentialStatus == "Approved" || normalizedEventStatus == "pending" || isInProgressApproved){
            documenticon = 'description'
            this.tableColumns = this.tableColumns.filter(column => column.columnId !== 'delete')
          }else{
          this.tableColumns = this.tableColumns.filter(column => column.columnId !== 'delete')
          this.tableColumns = this.tableColumns.filter(column => column.columnId !== 'preview')
          this.tableColumns = this.tableColumns.filter(column => column.columnId !== 'description')
          }
        }
        const loggedUserDetails = JSON.parse(localStorage.getItem("loggedUserDetails") || '{}')
        let fullName:any
        if(Existing && Existing['demographics'] && (Existing['demographics']['firstName'] &&  Existing['demographics']['lastName'])){
          fullName =  `${ Existing['demographics']['firstName']} ${ Existing['demographics']['lastName']}`
        }else{
        fullName = (loggedUserDetails['firstName'] && loggedUserDetails['lastName']) ? `${loggedUserDetails['firstName']}, ${loggedUserDetails['lastName']}` : ""
        }
        let actionValue = this.getAction(Existing['dentistInfo'],credential) 
        let overjetStatus = overjetStatusRaw
        let credentialEventStatus = credentialEventStatusRaw
        if (isInProgressApproved) {
          documenticon = 'description'
          this.tableColumns = this.tableColumns.filter(column => column.columnId !== 'delete')
        }
        if(this.getAction(Existing['dentistInfo'],credential) == 'Recred'){
          if(this.isNonparprovider(Existing)) {
            this.dataSource.data = []
            this.loader.hide()
            this.isLoading = false
            return
          }else{
          status = 'Recredential Due'
          }
        }else if(this.getAction(Existing['dentistInfo'],credential) == 'Edit'){
          status = 'Pending'
        }else if(isInProgressApproved){
          status = 'In Progress'
        }else if(credentialEventStatus && normalizedEventStatus == 'submitted'){
          if(normalizedOverjetStatus == "IN_PROGRESS" || normalizedOverjetStatus == "IN_COMMITTEE" || normalizedOverjetStatus == "IN_REVIEW"){
            status = 'In Progress'
          }else if(normalizedOverjetStatus == "APPROVED"){
            status = 'Approved'
          }else if(normalizedOverjetStatus == "REJECTED"){
            status = 'Rejected'
          }
          else{
            status = credentialEventStatus
          }
        }else if(credentialEventStatus == 'Ended'){
          status = "Ended"
        }
        if(status == 'Recredential Due' || normalizedOverjetStatus === 'AWAITING_INFO' || normalizedOverjetStatus === 'MISSING_INFO' || normalizedEventStatus != "submitted"
         && normalizedEventStatus != "draft" &&
          Existing['dentistInfo']?.credentialStatus != "Approved" &&
           normalizedEventStatus == "pending"){
          this.tableColumns = this.tableColumns.filter(column => column.columnId !== 'preview')
          this.tableColumns = this.tableColumns.filter(column => column.columnId !== 'description')
          this.tableColumns = this.tableColumns.filter(column => column.columnId !== 'delete')
        }
        var actionIcon = this.getAction(Existing['dentistInfo'], credential);
        // new code
        if(status == "Draft" || status == "Pending"){
          if(Existing && !Existing.error){
          if(Existing['dentistInfo'] && Existing['dentistInfo']['reCredentialDate']){
          if(!this.checkIsRecred(Existing['dentistInfo'], credential)){
            status = Existing['dentistInfo']?.credentialStatus ? Existing['dentistInfo']?.credentialStatus : ""
            deleteicon = ''
            previewicon = ''
            actionIcon = ''
            actionValue = ''
            if(credentialEventStatus?.toLowerCase() == 'submitted'){
              credentialEventStatus = ""
            }
            if(status == "Approved"){
              documenticon = 'description'
              this.tableColumns = this.tableColumns.filter(column => column.columnId !== 'delete')
              this.tableColumns.push(    {
                columnId: 'description',
                columnLabel: '',
                sort: false,
                headerData: null,
                columnData: {
                  cellType: LinkCellComponent ,
                  data: {
                    label: 'description',
                    actionData: "'description'",
                  },
                  otherParams : {
                    'actionKey' : 'description'
                  }
                },
                caseInsensitive: false,
              })
            }
          }else{
            if(status == "Pending" && this.isNonparprovider(Existing)) {
              this.dataSource.data = []
              this.loader.hide()
              this.isLoading = false
              return
            } 
          }
        }
      }
        }
        this.tableData = [{
          name: fullName ? fullName.charAt(0).toUpperCase() + fullName.slice(1) : '',
          credentialingDates: (actionValue == 'Continue' || actionValue == 'Edit' || credentialEventStatus?.toLowerCase() == 'submitted') ? "" :
            Existing['dentistInfo']?.credentialingPeriod ? `${this.formatDate("" + Existing['dentistInfo'].credentialingPeriod)} - ${this.formatDate("" + Existing['dentistInfo'].reCredentialDate)}` : "",
          recred: (actionValue == 'Continue' || actionValue == 'Edit' || credentialEventStatus?.toLowerCase() == 'submitted') ? "" : Existing['dentistInfo']?.reCredentialDate ? this.formatDate("" + Existing['dentistInfo'].reCredentialDate) : "",
          status: status ? status.charAt(0).toUpperCase() + status.slice(1) + `${(overjetStatus == "REJECTED" && credential.credentialingEvent?.overjetMessage) ? ` - ${credential.credentialingEvent?.overjetMessage}` : ""}` : Existing['dentistInfo']?.credentialStatus ? Existing['dentistInfo']?.credentialStatus : "",
          reason: credential.credentialingEvent?.overjetMessage,
          delete: deleteicon,
          preview: previewicon,
          description: documenticon,
          isSubmittedApplication: credentialEventStatus?.toLowerCase() == 'submitted'
        }]
        if (actionIcon) {
          const isColumnPresent = this.tableColumns.some(item => item.columnId == 'action');
          if(!isColumnPresent) {
            this.tableColumns.push({
              columnId: 'action',
              columnLabel: 'Action',
              sort: false,
              headerData: null,
              columnData: {
                cellType: LinkCellComponent,
                data: {
                  label: '',
                  actionData: "",
                },
              },
              caseInsensitive: false,
            })
          }
          this.tableData[0]['action'] = actionIcon;
        }
        this.dataSource.data = [...this.tableData];
        this.loader.hide();
        this.isLoading = false
      }
    }

  }
  checkIsRecred(el: any, credentialStatusData: any){ 
    //  Parse date safely  
    const recredDate: Date = this.parseYyyyMmDd("" + el.reCredentialDate);
    const today = new Date();
    const dueDate = new Date(recredDate);
    const value = Number(this.sharedService.credentialing_graceperiod);
    const gracePeriod =  !value || isNaN(value) ? 180 : value; 
    // 180 days before re-credential date
    dueDate.setDate(dueDate.getDate() - gracePeriod);
    //  Block only if TOO EARLY (more than 180 days before)
    if (today < dueDate) {
      return false
    } 
  //  Due / overdue
    return true
  }
  setLocalstorageDetails(dw: any, transac: any) {
    let dentistInfo = dw['dentistInfo'] ? dw['dentistInfo'] : {}
    localStorage.setItem('dentistInfo', JSON.stringify(dentistInfo));
    let demographic = dw['demographics'] ? dw['demographics'] : {}
    let locations = dw['locations'] && dw['locations'].length > 0 ? dw['locations'] : []
    localStorage.setItem('whLocations', JSON.stringify(locations));
    let workHistoryfromDw = dw['workHistory'] && dw['workHistory'].length > 0 ? dw['workHistory'] : []
    let workHistory = workHistoryfromDw.filter((item: any) => item.organizationName && item.organizationName.trim() != '');
    localStorage.setItem('warehouseworkhistories', JSON.stringify(workHistory));
    localStorage.setItem('workhistories', JSON.stringify(workHistory));
    let tinDetails = dw['taxEntity'] ? dw['taxEntity'] : {}
    localStorage.setItem('TINDetails', JSON.stringify(tinDetails));
    let payeeDetails = dw['payees'] ? dw['payees'] : []
    localStorage.setItem('payees', JSON.stringify(payeeDetails));
    localStorage.setItem('payeeDetails', JSON.stringify(payeeDetails));
    let status = ""
    if (transac?.error === true && dw) {
      localStorage.setItem('demographics', JSON.stringify(demographic));
      localStorage.setItem('locations', JSON.stringify(locations));
      const malpracticeCredential = this.getMalpracticeCredentialFromSearch(dw);
      if (Object.keys(malpracticeCredential).length > 0) {
        const credentialFromSearch = [{ ...malpracticeCredential }];
        localStorage.setItem('credential', JSON.stringify(credentialFromSearch));
      }

      this.workHistoryService.reloadFromStorage();
    } else if ((transac && !transac.error)) {
      const { dob, gender, ethnicity, specialtyId, cellphone, ...rest } = transac['demographics'];
      demographic = {
        ...rest,
        dob: dob,
        gender: gender,
        ethnicity: ethnicity,
        specialtyId: specialtyId,
        cellphone: cellphone,
      }
      status = transac['credentialingEvent']?.eventStatus;
      const malpracticeCredential = this.getMalpracticeCredentialFromSearch(dw);
      const credentials = Array.isArray(transac['credentials']) ? transac['credentials'] : [];
      if (credentials.length === 0) {
        credentials.push({});
      }
      credentials[0] = this.mergeCredentialWithDwFallback(credentials[0], malpracticeCredential);
      if (!credentials[0]['stateLicenseNumber']) {
        if (this.userDetails && this.userDetails['licenseNumber']) {
          credentials[0]['stateLicenseNumber'] = this.userDetails['licenseNumber'];
        }
      }
      localStorage.setItem('demographics', JSON.stringify(demographic));
      localStorage.setItem('credential', JSON.stringify(credentials))
      localStorage.setItem('credentialingEvent', JSON.stringify(transac['credentialingEvent']))
      localStorage.setItem('credentialingEventId', transac['credentialingEvent']?.credentialingEventId)
      localStorage.setItem('locationDirectories', JSON.stringify(transac['locationDirectories']))
      localStorage.setItem('documents', JSON.stringify(transac['documents']))
      localStorage.setItem('attestation', JSON.stringify(transac['attestation']))
      localStorage.setItem('attestationQuestions', JSON.stringify(transac['attestationQuestions']))
      localStorage.setItem('attestationResponses', JSON.stringify(transac['attestationResponses']))
      localStorage.setItem('workhistories', JSON.stringify(transac['workHistories']));
      const rawTaxEntities = transac['taxEntities'];
      const normalizedTaxEntities = Array.isArray(rawTaxEntities)
        ? rawTaxEntities
        : (Array.isArray(rawTaxEntities?.data) ? rawTaxEntities.data : []);
      const derivedLocationsFromTaxEntities = normalizedTaxEntities.flatMap((taxEntity: any) =>
        Array.isArray(taxEntity?.locations) ? taxEntity.locations : []
      ).map((location: any) => ({
        ...location,
        name: location?.name ?? location?.locationName ?? '',
        address1: location?.address1 ?? location?.locationAddress1 ?? location?.address ?? '',
        address2: location?.address2 ?? location?.locationAddress2 ?? '',
        city: location?.city ?? location?.locationCity ?? '',
        state: location?.state ?? location?.locationState ?? '',
        zip: location?.zip ?? location?.locationZip ?? '',
        voicePhone: location?.voicePhone ?? location?.locationVoicePhone ?? '',
        email: location?.email ?? location?.locationEmail ?? '',
        officeTypeID: location?.officeTypeID ?? location?.officeTypeId ?? null,
        dcaDocumentId: location?.dcaDocumentId ?? location?.dcaDocumentID ?? null
      }));
      const derivedPayeesFromTaxEntities = normalizedTaxEntities.flatMap((taxEntity: any) =>
        Array.isArray(taxEntity?.payees) ? taxEntity.payees : []
      ).map((payee: any) => ({
        ...payee,
        payeeLocation: payee?.payeeLocation ?? payee?.payeeAddress1 ?? '',
        payeeAddressLine1: payee?.payeeAddressLine1 ?? payee?.payeeAddress1 ?? ''
      }));
      const resolvedLocations = Array.isArray(transac['locations']) && transac['locations'].length > 0
        ? transac['locations']
        : derivedLocationsFromTaxEntities;
      const resolvedPayees = Array.isArray(transac['payees']) && transac['payees'].length > 0
        ? transac['payees']
        : derivedPayeesFromTaxEntities;
      localStorage.setItem('locations', JSON.stringify(resolvedLocations));
      localStorage.setItem('payees', JSON.stringify(resolvedPayees));
      localStorage.setItem('taxEntities', JSON.stringify(normalizedTaxEntities));
      this.workHistoryService.reloadFromStorage();
    }

  }
  hasCredentialValue(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    if (typeof value === 'string') {
      return value.trim().length > 0;
    }

    return true;
  }
  mergeCredentialWithDwFallback(credential: any, dwMalpracticeCredential: any): any {
    const mergedCredential = { ...(credential || {}) };
    const malpracticeCredentialEntries = Object.entries(dwMalpracticeCredential || {});

    for (const [key, value] of malpracticeCredentialEntries) {
      if (!this.hasCredentialValue(mergedCredential[key]) && this.hasCredentialValue(value)) {
        mergedCredential[key] = value;
      }
    }

    return mergedCredential;
  }
  getPolicyNumberOrHolderValue(malpractice: any): string {
    const policyCandidates = [
      malpractice?.policyNumber,
      malpractice?.policyHolder,
      malpractice?.policyHolderName
    ];

    const matchedPolicyValue = policyCandidates.find((candidate: any) => this.hasCredentialValue(candidate));
    if (!matchedPolicyValue) {
      return '';
    }

    return `${matchedPolicyValue}`.trim();
  }
  getMalpracticeCredentialFromSearch(dw: any): any {
    const malpracticeDetails = dw?.malpracticeDetails || [];
    if (!malpracticeDetails.length) {
      return {};
    }

    const malpractice = malpracticeDetails[0];
    const policyTypeDescription = (malpractice?.malpracticeInsurancePolicyTypeDescription || '').toLowerCase().trim();
    let policyType = '';
    if (policyTypeDescription === 'claims made' || policyTypeDescription === 'claims-made' || policyTypeDescription === 'claimsmade') {
      policyType = 'claimsMade';
    } else if (policyTypeDescription === 'occurrence') {
      policyType = 'occurrence';
    }

    const policyValue = this.getPolicyNumberOrHolderValue(malpractice);

    return {
      malpracticeCarrierName: malpractice?.insuranceCarrierName || malpractice?.carrier || '',
      malpracticePolicyHolder: policyValue,
      malpracticePolicyType: policyType,
      malpracticeLimitPerClaim: malpractice?.coverageLimitPerClaim ?? null,
      malpracticeLimitAggregate: malpractice?.coverageLimitAggregate ?? null,
      malpracticeExpirationDate: malpractice?.expirationDate ?? null
    };
  }
  formatDate(dateString: string): string {
    if (!dateString || dateString.length !== 8) return "";

    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);

    return `${month}/${day}/${year}`;
  }
  parseYyyyMmDd(dateString: string): Date {

    const year = Number(dateString.substring(0, 4));

    const month = Number(dateString.substring(4, 6)) - 1;

    const day = Number(dateString.substring(6, 8));

    return new Date(year, month, day);

  }
  parseYyyyMmDdForWorkhistory(dateString: string): string {

    const year = dateString.substring(0, 4);

    const month = dateString.substring(4, 6);

    const day = dateString.substring(6, 8);

    return `${year}/${month}/${day}`;

  }
  private getFirstNonEmptyLocationValue(source: any, keys: string[], defaultValue: any = null): any {
    for (const key of keys) {
      const value = source?.[key];
      if (value !== undefined && value !== null && `${value}`.trim() !== '') {
        return value;
      }
    }
    return defaultValue;
  }
  private parseLocationEffectiveDate(value: any): string | null {
    if (value === undefined || value === null) {
      return null;
    }
    const stringValue = value.toString().trim();
    if (!stringValue) {
      return null;
    }
    const datePart = stringValue.split('T')[0];
    if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
      return datePart;
    }
    const parsed = new Date(value);
    if (isNaN(parsed.getTime())) {
      return stringValue;
    }
    const year = parsed.getFullYear();
    const month = String(parsed.getMonth() + 1).padStart(2, '0');
    const day = String(parsed.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  private buildStartLocationPayload(locations: any[], userId: number, credentialingEventId: number): any[] {
    if (!Array.isArray(locations) || locations.length === 0) {
      return [];
    }

    return locations.map((location: any) => {
      const providerNetwork = this.getFirstNonEmptyLocationValue(location, ['providerNetwork'], '');
      const hasExplicitParticipation = location?.isParticipating === true || location?.isParticipating === false;
      const isParticipating = hasExplicitParticipation
        ? location?.isParticipating
        : providerNetwork === 'Participating'
          ? true
          : providerNetwork === 'Not participating'
            ? false
            : null;
      const payload: any = {
        locationId: this.getFirstNonEmptyLocationValue(location, ['locationId']),
        name: this.getFirstNonEmptyLocationValue(location, ['name', 'locationName'], ''),
        address: this.getFirstNonEmptyLocationValue(location, ['address1', 'locationAddress1', 'address'], ''),
        city: this.getFirstNonEmptyLocationValue(location, ['city', 'locationCity'], ''),
        state: this.getFirstNonEmptyLocationValue(location, ['state', 'locationState'], ''),
        zip: this.getFirstNonEmptyLocationValue(location, ['zip', 'locationZip'], ''),
        tin: this.getFirstNonEmptyLocationValue(location, ['tin', 'taxId', 'taxID'], ''),
        isPrimary: location?.isPrimary ?? (location?.primaryLocation ? true : false),
        userId: userId,
        credentialingEventId: credentialingEventId,
        stillPracticing: this.getFirstNonEmptyLocationValue(location, ['stillPracticing']),
        startPracticingAt: this.getFirstNonEmptyLocationValue(location, ['startPracticingAt']),
        endedPracticingAt: this.getFirstNonEmptyLocationValue(location, ['endedPracticingAt']),
        isParticipating: isParticipating,
        esLocationId: this.getFirstNonEmptyLocationValue(location, ['esLocationId']),
        dcaDocumentId: this.getFirstNonEmptyLocationValue(location, ['dcaDocumentId', 'dcaDocumentID']),
        officeTypeID: this.getFirstNonEmptyLocationValue(location, ['officeTypeID', 'officeTypeId']),
        voicePhone: this.getFirstNonEmptyLocationValue(location, ['voicePhone', 'locationVoicePhone']),
        email: this.getFirstNonEmptyLocationValue(location, ['email', 'locationEmail'])
      };
      const effectiveDate = this.parseLocationEffectiveDate(this.getFirstNonEmptyLocationValue(location, ['effectiveDate'])
      );
      
      if ((payload.startPracticingAt == null && payload.endedPracticingAt == null) && effectiveDate) {
        if (isParticipating === true) {
          payload.startPracticingAt = effectiveDate;
        }
        // Do not map effectiveDate to endedPracticingAt
      }
      return payload;
    }).filter((location: any) =>
      `${location?.name ?? ''}`.trim() !== '' &&
      `${location?.address ?? ''}`.trim() !== '' &&
      `${location?.city ?? ''}`.trim() !== '' &&
      `${location?.state ?? ''}`.trim() !== '' &&
      `${location?.zip ?? ''}`.trim() !== '' &&
      `${location?.tin ?? ''}`.trim() !== ''
    );
  }

getAction(el: any, credentialStatusData: any): any {
 
  this.showActionRequired = false;
  const eventStatus = credentialStatusData?.credentialingEvent?.eventStatus;
  const normalizedEventStatus = `${eventStatus ?? ''}`.trim().toLowerCase();
 
  //  Draft overrides all

  if (normalizedEventStatus === 'draft') {

    this.action = "Draft";

    return "Continue";

  }
 
  //  Pending

  let overjetStatus = credentialStatusData.credentialingEvent?.overJetStatus

  if (normalizedEventStatus === 'pending' || overjetStatus === 'AWAITING_INFO' || overjetStatus === 'MISSING_INFO') {

    this.action = "Edit";

    this.showActionRequired = true;

    return "Edit";

  }
 
  // Guard check for el & reCredentialDate

  if (!el?.reCredentialDate) {

    return ""

  }
 
  //  Parse date safely

  const recredDate: Date = this.parseYyyyMmDd("" + el.reCredentialDate);

  if (normalizedEventStatus || !recredDate) {

    return ""

  }
  const today = new Date();

  const dueDate = new Date(recredDate);

  const value = Number(this.sharedService.credentialing_graceperiod);
 
  const gracePeriod =  !value || isNaN(value) ? 180 : value;
 
  // 180 days before re-credential date

  dueDate.setDate(dueDate.getDate() - gracePeriod);

    //  Block only if TOO EARLY (more than 180 days before)
    if (today < dueDate) {
      return "";
    }
 
  //  Due / overdue

  this.action = "Recred";

  this.showActionRequired = true;

  return "Recred";

}

 

startCredentialing(){
  let payload = {
    "npi": this.getCredentialpayload['npi'],
     "licenseNumber": this.getCredentialpayload['licenseNumber'],
     "userId":this.getCredentialpayload['userId'],
     "credentialingStatus" : this.action == "Recred" ? "Recredentialing" : "Initial_Credentialing"
    }
  this.sharedService.startCredentialling(payload).pipe(catchError((error:any)=>{
    return throwError(() => {
    this.sharedService.logError("APIFailed","FileMainComponent - startCredentialling, Method:startCredentialing", this.router.url.split('?')[0], error).subscribe();
    }) 
  }))
    .subscribe((response: any) => {
      localStorage.setItem('credentialingEventId', response.credentialingEventId)
      if (this.action == "Recred" || this.action == "start") {
        this.callSaveDemographicsLocationAndWorkhistory(response.credentialingEventId)
      } else {
        this.loader.hide()
        this.router.navigate(['/credentialing/information']);
      }
    })
}

  callSaveDemographicsLocationAndWorkhistory(credentialEventId: any) {
    const locations: any[] = JSON.parse((localStorage.getItem('locations') || '[]'))
    const workhistories: any[] = JSON.parse((localStorage.getItem('workhistories') || '[]'))
    const demographics: any = JSON.parse((localStorage.getItem('demographics') || '{}'))
    const dentistInfo = JSON.parse((localStorage.getItem('dentistInfo') || '{}'))
    const { DOB, specialtyId, cellPhone,email, ...restdemograhics } = demographics
    const dentalSchool = workhistories ? workhistories[0]?.organizationName : ''
    const yearGraduated = workhistories ? workhistories[0]?.endDate : ''
    const degree = dentistInfo ? dentistInfo.abbreviation : ''
    const userId = this.getCredentialpayload['userId']
    const TINDetails: any[] = JSON.parse((localStorage.getItem('TINDetails') || '[]'))
    const payeeRows: any[] = JSON.parse((localStorage.getItem('payees') || '[]'));
    const normalizeTinIdentifier = (value: any): string => `${value ?? ''}`.replace(/[^0-9]/g, '');
    const usedPayeeIndexes = new Set<number>();
    const normalizeText = (value: any): string => `${value ?? ''}`.trim().toLowerCase();
    const findPayeeForTin = (tinInfo: any, tinIndex: number) => {
      const normalizedTin = normalizeTinIdentifier(tinInfo?.tin ?? tinInfo?.taxId);
      const tinTaxEntityId = `${tinInfo?.taxEntityId ?? ''}`.trim();
      const tinTaxEntityName = normalizeText(tinInfo?.taxEntityName ?? tinInfo?.taxEntityBusinessName);
      const payeeList = Array.isArray(payeeRows) ? payeeRows : [];
      const matchedIndex = payeeList.findIndex((payee: any, payeeIndex: number) => {
        if (usedPayeeIndexes.has(payeeIndex)) {
          return false;
        }
        const payeeTinMatch = normalizedTin
          ? normalizeTinIdentifier(payee?.tin ?? payee?.taxId ?? payee?.taxID) === normalizedTin
          : false;
        const payeeTaxEntityIdMatch = tinTaxEntityId && `${payee?.taxEntityId ?? ''}`.trim() === tinTaxEntityId;
        const payeeTaxEntityNameMatch = tinTaxEntityName &&
          normalizeText(payee?.taxEntityName ?? payee?.taxEntityBusinessName) === tinTaxEntityName;
        return payeeTinMatch || payeeTaxEntityIdMatch || payeeTaxEntityNameMatch;
      });

      if (matchedIndex >= 0) {
        usedPayeeIndexes.add(matchedIndex);
        return payeeList[matchedIndex];
      }

      if (tinIndex >= 0 && tinIndex < payeeList.length && !usedPayeeIndexes.has(tinIndex)) {
        usedPayeeIndexes.add(tinIndex);
        return payeeList[tinIndex];
      }

      const nextUnusedPayeeIndex = payeeList.findIndex((_: any, payeeIndex: number) => !usedPayeeIndexes.has(payeeIndex));
      if (nextUnusedPayeeIndex >= 0) {
        usedPayeeIndexes.add(nextUnusedPayeeIndex);
        return payeeList[nextUnusedPayeeIndex];
      }

      return null;
    };
    const getPayeeField = (source: any, keys: string[]) => {
      for (const key of keys) {
        const value = source?.[key];
        if (value !== undefined && value !== null && `${value}`.trim() !== '') {
          return value;
        }
      }
      return '';
    };
    const demographicsPayload = {
      credentialEventId: credentialEventId,
      createdUserId: userId,
      dateOfBirth: DOB,
      specialtyId: specialtyId,
      phone: cellPhone,
      dentalSchool: dentalSchool ? dentalSchool : '',
      degree: degree ? degree : '',
      yearGraduated: yearGraduated ? this.sharedService.formatDateString(yearGraduated) : '',
      email: email ? email : this.userDetails?.emailAddress,
      ...restdemograhics
    }
    let credential: any[] = JSON.parse(localStorage.getItem('credential')!) || [];

    if (!credential || !credential[0] || !credential[0]['stateLicenseNumber']) {
      if (this.userDetails && this.userDetails['licenseNumber']) {
        if (!credential || credential.length === 0) {
          credential.push({
            stateLicenseNumber: this.userDetails['licenseNumber']
          });
        } else {
          credential[0]['stateLicenseNumber'] = this.userDetails['licenseNumber'];
        }
      }
    }
    localStorage.setItem('credential', JSON.stringify(credential));
    const dentistInfoForCredential = JSON.parse((localStorage.getItem('dentistInfo') || '{}'));
    const credentialInput = Array.isArray(credential) && credential.length > 0 ? credential[0] : null;
    const getFirstCredentialValue = (sources: any[], keys: string[], defaultValue: any = null) => {
      for (const source of sources) {
        for (const key of keys) {
          const value = source?.[key];
          if (this.hasCredentialValue(value)) {
            return value;
          }
        }
      }
      return defaultValue;
    };
    const serializeCredentialDate = (value: any): string | null => {
      if (!this.hasCredentialValue(value)) {
        return null;
      }
      const rawValue = `${value}`.trim();
      if (/^\d{8}$/.test(rawValue)) {
        const year = rawValue.slice(0, 4);
        const month = rawValue.slice(4, 6);
        const day = rawValue.slice(6, 8);
        return `${year}-${month}-${day}`;
      }

      const parsed = new Date(rawValue);
      if (isNaN(parsed.getTime())) {
        return rawValue;
      }

      const pad = (num: number) => String(num).padStart(2, '0');
      const isUtcMidnight =
        parsed.getUTCHours() === 0 &&
        parsed.getUTCMinutes() === 0 &&
        parsed.getUTCSeconds() === 0 &&
        parsed.getUTCMilliseconds() === 0;

      if (isUtcMidnight) {
        return `${parsed.getUTCFullYear()}-${pad(parsed.getUTCMonth() + 1)}-${pad(parsed.getUTCDate())}`;
      }

      return `${parsed.getFullYear()}-${pad(parsed.getMonth() + 1)}-${pad(parsed.getDate())}`;
    };
    const resolvedStateLicenseNumber = getFirstCredentialValue(
      [credentialInput, dentistInfoForCredential, this.userDetails],
      ['stateLicenseNumber', 'licenseNumber']
    ) ?? '';
    const resolvedCdsLicenseNumber = getFirstCredentialValue(
      [credentialInput, dentistInfoForCredential],
      ['cdsLicenseNumber', 'cDSLicenseNumber', 'cdsLicense']
    );
    const resolvedDeaLicenseNumber = getFirstCredentialValue(
      [credentialInput, dentistInfoForCredential],
      ['deaLicenseNumber', 'dEALicenseNumber', 'deaLicense', 'dEALicense']
    );
    const resolvedCdsExpirationDate = serializeCredentialDate(getFirstCredentialValue(
      [credentialInput, dentistInfoForCredential],
      ['cDSExpirationDate', 'cdsLicenseExpirationDate', 'cDSLicenseExpirationDate']
    ));
    const resolvedDeaExpirationDate = serializeCredentialDate(getFirstCredentialValue(
      [credentialInput, dentistInfoForCredential],
      ['dEAExpirationDate', 'deaLicenseExpirationDate', 'dEALicenseExpirationDate']
    ));
    const isCdsSelected = credentialInput?.cds === true || credentialInput?.cds === 'true' || this.hasCredentialValue(resolvedCdsLicenseNumber) || this.hasCredentialValue(resolvedCdsExpirationDate);
    const isDeaSelected = credentialInput?.dea === true || credentialInput?.dea === 'true' || this.hasCredentialValue(resolvedDeaLicenseNumber) || this.hasCredentialValue(resolvedDeaExpirationDate);
    const credentialPayload = credentialInput
      ? {
          credentialId: credentialInput?.credentialID ?? credentialInput?.credentialId ?? null,
          credentialingEventId: credentialEventId,
          stateLicenseNumber: resolvedStateLicenseNumber,
          cDSLicenseNumber: isCdsSelected ? resolvedCdsLicenseNumber : null,
          dEALicenseNumber: isDeaSelected ? resolvedDeaLicenseNumber : null,
          painManagementNote: credentialInput?.painManagementNote ?? null,
          specialtyLicenseNumber: credentialInput?.specialtyLicenseNumber ?? null,
          malpracticeCarrierName: credentialInput?.malpracticeCarrierName ?? null,
          malpracticePolicyHolder: credentialInput?.malpracticePolicyHolder ?? null,
          malpracticeLimitPerClaim: credentialInput?.malpracticeLimitPerClaim
            ? `${credentialInput.malpracticeLimitPerClaim}`.replace('$', '')
            : null,
          malpracticeLimitAggregate: credentialInput?.malpracticeLimitAggregate
            ? Number(`${credentialInput.malpracticeLimitAggregate}`.replace('$', ''))
            : null,
          malpracticeExpirationDate: serializeCredentialDate(credentialInput?.malpracticeExpirationDate),
          malpracticePolicyType: credentialInput?.malpracticePolicyType ?? null,
          anesthesiaSedationLicense: credentialInput?.anesthesiaSedationLicense ?? null,
          stateLicenseEffectiveDate: serializeCredentialDate(getFirstCredentialValue([credentialInput, dentistInfoForCredential], ['stateLicenseEffectiveDate', 'licenseEffectiveDate'])),
          dEAExpirationDate: isDeaSelected ? resolvedDeaExpirationDate : null,
          cDSExpirationDate: isCdsSelected ? resolvedCdsExpirationDate : null,
          specialtyLicenseEffectiveDate: serializeCredentialDate(credentialInput?.specialtyLicenseEffectiveDate),
          anesthesiaEffectiveDate: serializeCredentialDate(credentialInput?.anesthesiaEffectiveDate),
          userId: userId || -1
        }
      : null;
    const locationPayload = this.buildStartLocationPayload(locations, userId, Number(credentialEventId));

    const workhistoryPayload = workhistories.map((workhistory: any) => {
      const { phoneNumber, phoneExtension, ...rest } = workhistory;

      return {
        ...rest,
        userId: userId,
        credentialingEventId: credentialEventId,
        endDate: workhistory.endDate ? this.parseYyyyMmDdForWorkhistory(String(workhistory.endDate)) : null,
        phone: phoneNumber
      };
    });
    const tinPayload = TINDetails && TINDetails.length > 0 ? TINDetails.map((tinInfo: any, tinIndex: number) => {
      const payeeMatch = findPayeeForTin(tinInfo, tinIndex);
      const { tin,taxEntityBusinessName,taxIDTypeID,...rest } = tinInfo;
      return {
        ...rest,
        taxId : tin || tinInfo?.taxId || '',
        taxTypeId : taxIDTypeID ?? tinInfo?.taxTypeId ?? 0,
        taxEntityName : taxEntityBusinessName || tinInfo?.taxEntityName || '',
        payeeName: getPayeeField(tinInfo, ['payeeName']) || getPayeeField(payeeMatch, ['payeeName', 'name']),
        payeeAddressLine1: getPayeeField(tinInfo, ['payeeAddressLine1', 'payeeAddress1', 'payeeLocation']) || getPayeeField(payeeMatch, ['payeeAddressLine1', 'payeeAddress1', 'payeeAddress', 'payeeLocation', 'address1', 'address']),
        payeeAddressLine2: getPayeeField(tinInfo, ['payeeAddressLine2', 'payeeAddress2']) || getPayeeField(payeeMatch, ['payeeAddressLine2', 'payeeAddress2', 'address2']),
        payeeCity: getPayeeField(tinInfo, ['payeeCity']) || getPayeeField(payeeMatch, ['payeeCity', 'city']),
        payeeState: getPayeeField(tinInfo, ['payeeState']) || getPayeeField(payeeMatch, ['payeeState', 'state']),
        payeeZip: getPayeeField(tinInfo, ['payeeZip']) || getPayeeField(payeeMatch, ['payeeZip', 'zip']),
        payeeEmail: getPayeeField(tinInfo, ['payeeEmail']) || getPayeeField(payeeMatch, ['payeeEmail', 'email']),
        payeeVoicePhone: getPayeeField(tinInfo, ['payeeVoicePhone', 'payeePhone']) || getPayeeField(payeeMatch, ['payeeVoicePhone', 'payeePhone', 'voicePhone', 'phone']),
        payeeNPI: getPayeeField(tinInfo, ['payeeNPI', 'providerNpi2', 'npi2']) || getPayeeField(payeeMatch, ['payeeNPI', 'providerNpi2', 'npi2']),
        userId: userId,
        credentialingEventId: credentialEventId,
      };
    }) : [];

    const requests: any = {};

    if (locationPayload.length > 0) {
      requests.saveLocationResponse = this.sharedService
        .saveLocationPayeeTax({ locations: locationPayload })
        .pipe(catchError(err => of({ error: true, message: err })));
    }

    if (this.hasValidWorkHistory(workhistories) && workhistories.length > 0) {
      requests.saveWorkhistoryResponse = this.sharedService
        .saveWorkhistory(workhistoryPayload)
        .pipe(catchError(err => of({ error: true, message: err })));
    }

    if (this.hasValidTins([TINDetails]) && TINDetails.length >0) {
      requests.saveTinResponse = this.sharedService
        .saveLocationPayeeTax({ taxEntities: tinPayload })
        .pipe(catchError(err => of({ error: true, message: err })));
    }


    if (Object.keys(demographics).length > 0) {
      requests.saveDemographicsResponse = this.demographicService
        .saveDemographics(demographicsPayload)
        .pipe(catchError(err => of({ error: true, message: err })));
    }

    if (credentialPayload) {
      requests.saveCredentialResponse = this.dentalCredentialsService
        .saveCredentialing(credentialPayload)
        .pipe(catchError(err => of({ error: true, message: err })));
    }

    if (Object.keys(requests).length === 0) {
      this.loader.hide();
      this.router.navigate(['/credentialing/information']);
      return;
    }

    forkJoin(requests).subscribe((results: any) => {
      //demographics
      if (results.saveDemographicsResponse && results.saveDemographicsResponse.error) {
        this.sharedService.logError("APIFailed", "FileMainComponent - saveDemographics, Method:callSaveDemographicsLocationAndWorkhistory", this.router.url.split('?')[0], results.saveDemographicsResponse).subscribe();
      } else {
        const dentistInfo = JSON.parse(localStorage.getItem('demographics') || '{}')
        demographics['demoGraphicId'] = results.saveDemographicsResponse.demographicId
        demographics['firstName'] = dentistInfo.firstName ? dentistInfo.firstName : ""
        demographics['lastName'] = dentistInfo.lastName ? dentistInfo.lastName : ""
        demographics['middleName'] = dentistInfo.middleName ? dentistInfo.middleName : ""
        demographics['degree'] = degree ? degree : ''
        demographics['dentalSchool'] = dentalSchool ? dentalSchool : ''
        demographics['yearGraduated'] = yearGraduated ? this.sharedService.formatDateString(yearGraduated) : ''
        demographics['email'] = email ? email : this.userDetails?.emailAddress
        demographics['specialty'] = specialtyId ? specialtyId : ''
        localStorage.setItem('demographics', JSON.stringify(demographics));

      }
      // credentials
      if (results.saveCredentialResponse && results.saveCredentialResponse.error) {
        this.sharedService.logError("APIFailed", "FileMainComponent - saveCredentialing, Method:callSaveDemographicsLocationAndWorkhistory", this.router.url.split('?')[0], results.saveCredentialResponse).subscribe();
      } else if (results.saveCredentialResponse && credentialInput) {
        credential[0] = {
          ...credentialInput,
          credentialID: results.saveCredentialResponse?.CredentialId ?? credentialInput?.credentialID ?? credentialInput?.credentialId ?? null,
          credentialingEventId: credentialEventId
        };
        localStorage.setItem('credential', JSON.stringify(credential));
      }
      //Locations
      if (results.saveLocationResponse && results.saveLocationResponse.error) {
        this.sharedService.logError("APIFailed", "FileMainComponent - saveLocationPayeeTax, Method:callSaveDemographicsLocationAndWorkhistory", this.router.url.split('?')[0], results.saveLocationResponse).subscribe();
      } else {
        const savedLocations = this.getSavedLocationRecords(results.saveLocationResponse);
        const updatedLocations = locations.map((loc: any) => {
          const match = savedLocations.find((item: any) => item.esLocationId == loc.esLocationId);
          return {
            ...loc,
            locationId: match ? match.locationId : null,
            isPrimary: match ? match.isPrimary : null,
            isParticipating: match ? match.isParticipating : null
          };
        });
        localStorage.setItem('locations', JSON.stringify(updatedLocations))
      }
      // work history
      if (results.saveWorkhistoryResponse && results.saveWorkhistoryResponse.error) {
        this.sharedService.logError("APIFailed", "FileMainComponent - saveWorkhistory, Method:callSaveDemographicsLocationAndWorkhistory", this.router.url.split('?')[0], results.saveWorkhistoryResponse).subscribe();
      } else {
        if (workhistories && workhistories.length == 1) {
          workhistories[0].workHistoryId = results.saveWorkhistoryResponse[0]?.workHistoryId
          localStorage.setItem('workhistories', JSON.stringify(workhistories));
          this.workHistoryService.reloadFromStorage();
        }
      }
      // TIN
      if (results.saveTinResponse && results.saveTinResponse.error) {
        this.sharedService.logError("APIFailed", "FileMainComponent - saveLocationPayeeTax, Method:callSaveDemographicsLocationAndWorkhistory", this.router.url.split('?')[0], results.saveTinResponse).subscribe();
      } else {
        const savedTaxEntityResults = this.getSavedTaxEntityResults(results.saveTinResponse);
        const payeeRows = JSON.parse(localStorage.getItem('payees') || '[]');
        const payeeList = Array.isArray(payeeRows) ? payeeRows : [];
        const updatedTINs = TINDetails.map((tin: any, index: number) => {
          const match = savedTaxEntityResults[index];
          const normalizedTin = normalizeTinIdentifier(tin?.tin ?? tin?.taxId);
          const tinTaxEntityId = `${tin?.taxEntityId ?? ''}`.trim();
          const payeeMatch = payeeList.find((payee: any) => {
            const payeeTinMatch = normalizedTin
              ? normalizeTinIdentifier(payee?.tin ?? payee?.taxId) === normalizedTin
              : false;
            const payeeTaxEntityIdMatch = tinTaxEntityId && `${payee?.taxEntityId ?? ''}`.trim() === tinTaxEntityId;
            return payeeTinMatch || payeeTaxEntityIdMatch;
          });
          return {
            ...tin,
            taxEntityId: match ? match.taxEntityId : null,
            ...(payeeMatch ? { payeeAddress1: payeeMatch.payeeAddress } : {})
          };
        });
        localStorage.setItem('TINDetails', JSON.stringify(updatedTINs));
      }
      this.loader.hide()
      this.router.navigate(['/credentialing/information']);
    })

  }

  private getSavedLocationRecords(response: any): any[] {
    if (Array.isArray(response)) {
      return response;
    }

    const collections = [
      response?.locations,
      response?.saveLocationResponse,
      response?.locationResponse,
      response?.data?.locations,
      response?.data?.saveLocationResponse,
      response?.data?.locationResponse
    ];

    for (const collection of collections) {
      if (Array.isArray(collection)) {
        return collection;
      }
    }

    if (response?.locationId != null) {
      return [response];
    }
    if (response?.data?.locationId != null) {
      return [response.data];
    }

    return [];
  }

  private getSavedTaxEntityResults(response: any): any[] {
    if (Array.isArray(response?.results)) {
      return response.results;
    }

    const taxEntitiesResponse = response?.taxEntities;
    if (Array.isArray(taxEntitiesResponse?.results)) {
      return taxEntitiesResponse.results;
    }

    if (Array.isArray(taxEntitiesResponse)) {
      return taxEntitiesResponse;
    }

    return [];
  }

deletePopupCall(){
  let alertMessage = `Please confirm you are about to delete your application? You will not be able to find this application again once it is deleted.`;
  let dialogRef=   this.dialog.open(DeletePopupComponent, {
      disableClose: true,
       data: { message: alertMessage},
       width: '550px',
       backdropClass: '',
       hasBackdrop: true,
     });
     dialogRef.afterClosed().subscribe((result:any) => {
       if(result==true){
       this.loader.show();
       this.isLoading = true
       this.callSearchAndGetCredentaildataApis()
       }else{
       this.loader.hide();
       }
     });
}

callToken(params:any){
  const code = params['code'];
  const state = params['state'];
  let payload ={
    grant_type: 'authorization_code',
    client_id: environment.auth0Config.clientIdExternal,
    code: code,
    redirect_uri: environment.redirect_uri_external
  }
  this.sharedService.getAuthToken(payload).subscribe({
    next: (data:any) => {
    this.sharedService.setStorageAuth0(data, 'external')
    this.authService.saveTokens(data);
    this.callDdmoToken(data.access_token, data.id_token)
    },      
    error: (err:any) => { 
      this.sharedService.logError("APIFailed","FileMainComponent - getAuthToken, Method:callToken", this.router.url.split('?')[0], err).subscribe();
      this.authService.logout();
    }
  });

}
callDdmoToken(accessToken:any,idToken:any){
  this.sharedService.callToken(idToken).pipe(catchError((error:any)=>{
      return throwError(() => {
      this.sharedService.logError("APIFailed","FileMainComponent - callToken, Method:callDdmoToken", this.router.url.split('?')[0], error).subscribe();
      }) 
    }))
    .subscribe((response:any)=>{
      let ddmoToken = response.ddmo?.accessToken
      localStorage.setItem('accessToken', ddmoToken)
      localStorage.setItem('ddmoTokenExpiry', response.ddmo?.expiresOn);
      this.authService.initializeAuthState();
      this.getLoggedUserDetails()
    })
  
}
hasValidValue(obj: any): boolean {
  if (!obj || typeof obj !== 'object') {
    return false;
  }
 
  return Object.values(obj).some(
    value => value !== null && value !== undefined && value !== ''
  );
}
hasValidWorkHistory(workHistory: any[]): boolean {
  if (!Array.isArray(workHistory) || workHistory.length === 0) {
    return false;
  }
 
  return workHistory.some(item => this.hasValidValue(item));
}
hasValidLocations(locations: any[]): boolean {
  if (!Array.isArray(locations) || locations.length === 0) {
    return false;
  }
 
  return locations.some(location => this.hasValidValue(location));
}
hasValidTins(tins: any[]): boolean {
  if (!Array.isArray(tins) || tins.length === 0) {
    return false;
  }
 
  return tins.some(tin => this.hasValidValue(tin));
}
logRequest(result:any){
  let auditLog:any={};
  auditLog["websiteCodeId"] = 50;
  auditLog["trailType"]='Search';
  auditLog["trailWebSessionId"]=localStorage.getItem("trailWebSessionId")?.toUpperCase();
  auditLog["absolutePath"]= this.router.url.includes('?')? this.router.url.split('?')[0]: this.router.url;
  let userId = parseInt(localStorage.getItem("loggedUserId")!);
  auditLog["userId"] = userId ? userId : 0
  auditLog["impersonateId"]=0;
  auditLog["firstName"]=`${result.firstName}`;
  auditLog["lastName"]=`${result.lastName}`;
  auditLog["providerId"]=result['npi']?.trim()||0;
  this.sharedService.logWebTrailSearch(auditLog).subscribe(data=>{
  });
}
getLoggedUserDetails() {
  let emailAddress = localStorage.getItem("user_email"); 
  let payload = {
    emailAddress: emailAddress
  }; 
  this.sharedService.searchUser(payload).subscribe({
    next: (res: any) => { 
      if (!res?.users || res.users.length === 0) {
        return;
      }
      let result = res.users[0];
      this.saveUser(result);
      localStorage.setItem("loggedUserDetails", JSON.stringify(result));
      this.sharedService.updateUsername(`${result.firstName} ${result.lastName}`);
      localStorage.setItem("loggedUserId", result['userId']);
      this.logRequest(result);
      let payload = {
        "SearchCredentialPayload": {
          "NPI": result['npi']?.trim(),
          "LicenseNumber": Number(result['licenseNumber'])
        },
        "getCredentialpayload": {
          "npi": result['npi']?.trim(),
          "licenseNumber": result['licenseNumber'],
          "userId": result['userId']
        }
      };
      this.SearchCredentialPayload = payload['SearchCredentialPayload'];
      this.getCredentialpayload = payload['getCredentialpayload'];
      localStorage.setItem("SearchCredentialPayload", JSON.stringify(this.SearchCredentialPayload));
      localStorage.setItem("getCredentialpayload", JSON.stringify(this.getCredentialpayload));
      this.loader.show();
      this.isLoading = true
      this.getCredentialingResources()
      this.callSearchAndGetCredentaildataApis();
    },
    error: (error) => {
      if(error && error.error.message == 'User is not present in dentist_mo or dentist_sc'){
        this.router.navigate(['/login'])
        this.userTermedPopupCall()
      }
      this.loader.hide();
      this.isLoading = false
      this.sharedService.logError("APIFailed","FileMainComponent - searchUser, Method:getLoggedUserDetails", this.router.url.split('?')[0], error).subscribe();
    }
  });
}
 
setImpersonatedPayload(){
  const loggedUserDetails = JSON.parse(localStorage.getItem("loggedUserDetails") || '{}')
  let licenseNumber = loggedUserDetails?.licenseNumber;
  let payload ={
    "SearchCredentialPayload": {
      "NPI": loggedUserDetails?.npi?.trim(),
      "LicenseNumber": Number(licenseNumber)
    },
    "getCredentialpayload": {
      "npi": loggedUserDetails?.npi?.trim(),
      "licenseNumber": licenseNumber,
      "userId": loggedUserDetails?.userId
    }
  }
  this.SearchCredentialPayload = payload['SearchCredentialPayload']
  this.getCredentialpayload = payload['getCredentialpayload']
  localStorage.setItem("SearchCredentialPayload",JSON.stringify(this.SearchCredentialPayload))
  localStorage.setItem("getCredentialpayload",JSON.stringify(this.getCredentialpayload))
  this.loader.show()
  this.callSearchAndGetCredentaildataApis()
}
clearLocalStorageData(){
  const keys = ["demographics","dentistInfo","locations","workhistories",
    "credentialingEvent","credentialingEventId","locationDirectories",
    "documents","attestation", "credential", "isUniformRequirementsRead", 
    "attestationQuestions","attestationResponses", "payees","TINDetails"
  ]
  keys.forEach(key => {
    localStorage.removeItem(key)
  });
}
  saveUser(userData: any) {
    let payload: any = {
      "userId": userData.userId,
      "activeFlg": 1,
      "setTermAndCondDate": false,
      "setLoginDate": true,
      "modifiedDate": new Date().toISOString().replace(/\.\d{3}Z$/, 'Z'),
      "impersonatedByUserId": userData.impersonatedByUserId,
      "modifiedUserId": userData.userId
    }
    let uuid = uuid4();
    localStorage.setItem("trailWebSessionId", uuid)
    payload['trailWebSessionId'] = uuid;


    this.sharedService.saveUser(payload).pipe(catchError((error: any) => {
      return throwError(() => {
      this.sharedService.logError("APIFailed","FileMainComponent - saveUser, Method:saveUser", this.router.url.split('?')[0], error).subscribe();
      })
    }))
      .subscribe((response: any) => {
      })
  }

  userTermedPopupCall(){
    this.loader.hide();
    let alertMessage = `Dentist’s account has been termed. Please reach out to Provider Relations at professionalrelationsteam@deltadentalmo.com for assistance.`;
    let dialogRef=   this.dialog.open(UserTermedComponent, {
        disableClose: true,
         data: { message: alertMessage},
         width: '550px',
         backdropClass: '',
         hasBackdrop: true,
       });
       dialogRef.afterClosed().subscribe((result:any) => {
         if(result==true){
          this.authService.logout();
         }
       });
  }
  getCredentialingResources(){
    this.sharedService.getCMSContent("credentialing").subscribe((res:any)=>{
      const resData = res; 
      let resourceUri = ''; 
      let gracePeriod = '' ;
      let attestationText = '';      
      resData.forEach((item: any) => {
        if (item?.fields?.title === 'credentialing_dashboard') {
          const contentArray = item?.fields?.content?.content;       
          if (contentArray?.length) {
            const paragraph = contentArray[0]?.content;  
            const linkNode = paragraph?.find(
              (node: any) => node.nodeType === 'hyperlink'
            );       
            resourceUri = linkNode?.data?.uri || '';
          }
        }
        if (item?.fields?.title === 'credentialing_graceperiod') {
          const contentArray = item?.fields?.content?.content;       
          if (contentArray?.length) {
            const paragraph = contentArray[0]?.content;  
            const linkNode = paragraph?.find(
              (node: any) => node.nodeType === 'text'
            );       
            gracePeriod = linkNode?.value || 0;
          }
        }
        if (item?.fields?.title === 'credentialing_acceptattestation') {
          const contentArray = item?.fields?.content?.content;    
            if (contentArray?.length) {
              attestationText = contentArray
                .map((p: any) => {
                  return `<p>` + p.content.map((c: any) => {
                    let text = c.value || '';
                    if (c.marks?.some((m: any) => m.type === 'bold')) {
                      text = `<strong>${text}</strong>`;
                    }
                    return text;
                  }).join('') + `</p>`;
                })
                .join('');
                    } 
                  }
      });
      this.sharedService.resourceURL = resourceUri
      this.sharedService.credentialing_graceperiod = gracePeriod
      this.sharedService.credentialing_acceptattestation = attestationText;
      localStorage.setItem("credentialing_acceptattestation", attestationText);
    })
  }
  isNonparprovider(dw:any){
    if(dw){
      const locations = dw['locations'] && dw['locations'].length > 0 ? dw['locations'] : [];
      const dentistInfo = dw['dentistInfo'] ? dw['dentistInfo'] : {};
      if(dentistInfo?.reCredentialDate){
        const isNonPar =
        locations.length > 0 &&
        locations.every(
        (loc: any) =>
        loc?.providerNetwork?.toLowerCase() === 'not participating'
        );
      return isNonPar;
      }
      else{
        return false;
      }
    }else{
      return false;
    }
  }
deleteCredentialApplication() {
  const payload = {
    credentialingEventId: localStorage.getItem("credentialingEventId"),
    userId: localStorage.getItem("loggedUserId")
  };
  this.sharedService.deleteCredentialApplication(payload).subscribe({
    next: (res: any) => {
    },
    error: (err) => {
      this.sharedService.logError("APIFailed","FileMainComponent - deleteCredentialApplication, Method:deleteCredentialApplication", this.router.url.split('?')[0],err ).subscribe();
    }
  });
}
}